import { Card } from '@repo/shadcn';

import { IwForm } from '@components/form';
import { HeaderBreadcrumb } from '@components/ui';

import { Route } from '@/constants';

import {
    CreateStockAdjustmentProvider,
    useCreateStockAdjustmentContext,
} from './context';
import { ProductSelector } from './product-selector.component';
import { CreateStockAdjustmentSchema } from './schema';
import { StockVariationList } from './stock-variations.component';

export const CreateStockAdjustmentComponent = () => {
    const { handleSubmitAdjustment } = useCreateStockAdjustmentContext();

    return (
        <IwForm
            logErrors={true}
            schema={CreateStockAdjustmentSchema}
            initialValues={{ items: [] }}
            onSubmit={handleSubmitAdjustment as any}
        >
            <Card className={'p-4'}>
                <div className={'space-y-4'}>
                    <HeaderBreadcrumb
                        showHomeLink={true}
                        items={[
                            {
                                label: 'Stock Adjustments',
                                href: Route.ADJUSTMENT_STOCKS,
                            },
                            { label: 'Create Stock Adjustment' },
                        ]}
                    />
                    <h2 className={'font-medium'}>Adjust Stock</h2>
                </div>

                <div className={'mt-4 space-y-4'}>
                    <ProductSelector />
                    <StockVariationList />
                </div>
            </Card>
        </IwForm>
    );
};

export const CreateStockAdjustment = () => {
    return (
        <CreateStockAdjustmentProvider>
            <CreateStockAdjustmentComponent />
        </CreateStockAdjustmentProvider>
    );
};

CreateStockAdjustment.displayName = 'CreateStockAdjustment';
